import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

const responseSchema = z.array(
  z.object({
    referrerName: z.string(),
    referrerCode: z.string(),
    bonusValue: z.number().optional(),
    bonusPaid: z.boolean().optional(),
    bonusType: z.string().optional(),
    bonusRequirementMessage: z.string().optional(),
    bonusExpectationMessage: z.string().optional(),
    expiresAt: z.string().datetime().optional(),
  })
);

export type GetReferralsResponse = z.infer<typeof responseSchema>;

export function useGetReferrals(
  params: { enabled?: boolean },
  options: UseGetQueryOptions<GetReferralsResponse> = {}
): UseQueryResult<GetReferralsResponse | undefined> {
  const { enabled = true } = params;

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/agentprofile/referrals`,
    responseSchema,
    enabled,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_REFERRALS_FAILURE,
    },
    cacheTime: 15 * 60_000,
    staleTime: 5 * 60_000,
    ...options,
  });
}
